(() => {
  if (window.__guttifulExitIntentInit) return;
  window.__guttifulExitIntentInit = true;

  const STORAGE_KEY = 'guttiful_exit_intent_shown';
  const ARM_DELAY_MS = 4000;

  const popup = document.getElementById('ExitIntentPopup');
  if (!popup) return;

  let armed = false;
  let shown = false;

  try {
    shown = sessionStorage.getItem(STORAGE_KEY) === 'true';
  } catch (e) {
    shown = false;
  }

  const openPopup = () => {
    if (shown || !armed) return;
    shown = true;
    popup.hidden = false;
    document.body.classList.add('exit-intent-popup-open');
    try {
      sessionStorage.setItem(STORAGE_KEY, 'true');
    } catch (e) {
      /* ignore */
    }
  };

  const closePopup = () => {
    popup.hidden = true;
    document.body.classList.remove('exit-intent-popup-open');
  };

  popup.addEventListener('click', (event) => {
    if (event.target.closest('[data-exit-intent-close]')) {
      closePopup();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !popup.hidden) {
      closePopup();
    }
  });

  if (popup.querySelector('[data-exit-intent-just-subscribed]')) {
    armed = true;
    openPopup();
    return;
  }

  if (shown) return;

  setTimeout(() => {
    armed = true;
  }, ARM_DELAY_MS);

  document.addEventListener('mouseout', (event) => {
    if (event.clientY <= 0 && !event.relatedTarget) {
      openPopup();
    }
  });
})();
